<div mat-dialog-title fxLayout="row" fxLayoutAlign="space-between top">
  File Uploader
  <div>
    <button *ngIf="isActiveUpload" mat-icon-button (click)="onNoClick(false)" id="minimize-upload" alt="minimize"
      title="minimize">
      <mat-icon>picture_in_picture</mat-icon>
    </button>
    <button mat-icon-button (click)=" onNoClick(true)" id="close-upload" alt="close" title="close">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>

<mat-dialog-content class="uploader-dialog-content" [class.empty]="isEmpty" mat-dialog-content>
  <ng-template #folderUpload>
    <button class="add-local-button" mat-button [matMenuTriggerFor]="uploadMenu">
      <span>Add Files</span>
      <mat-icon>keyboard_arrow_down</mat-icon>
    </button>
    <mat-menu class="upload-menu" #uploadMenu="matMenu">
      <button class="add-local-button menu-item" mat-button>
        <span>Add File</span>
        <input type="file" multiple="multiple" name="files[]" (change)="handleFileInput($event)" />
      </button>
      <button class="add-local-button menu-item" mat-button>
        <span>Add Folder</span>
        <input type="file" webkitdirectory directory multiple="multiple" name="files[]"
          (change)="handleFileInput($event)" />
      </button>
    </mat-menu>
  </ng-template>
  <form *ngIf="isEmpty">
    <span class="message">Drag a file here to upload</span>
    <span class="message">or</span>
    <div *ngIf="!isFolderUploadAllowed; else folderUpload" class="add-local-button single mat-button">
      <span>Add Files</span>
      <input type="file" multiple="multiple" name="files[]" (change)="handleFileInput($event)" />
    </div>
  </form>
  <div *ngIf="!isEmpty">
    <div fxLayout="row" fxLayoutAlign="space-between top">
      <div *ngIf="!isFolderUploadAllowed; else folderUpload" class="add-local-button single mat-button">
        <span>Add Files</span>
        <input type="file" multiple="multiple" name="files[]" (change)="handleFileInput($event)" />
      </div>
      <button [disabled]="isActiveUpload" class="delete-button" mat-button (click)="handleDeleteAll()">
        Delete All
      </button>
    </div>
    <div class="upload-table">
      <div class="upload-table-row header-row" fxLayout="row">
        <div class="name">Name</div>
        <div class="size">Size</div>
        <div class="status">Status</div>
        <div class="actions top">Action</div>
      </div>
      <div class="rows" *ngIf="collection">
        <div *ngFor="let item of collection.items" class="upload-table-row" fxLayout="row">
          <div class="name" [matTooltip]="item.name">
            <mat-icon *ngIf="item.files" class="file-icon accent-icon">folder</mat-icon>
            <mat-icon *ngIf="!item.files" class="file-icon">insert_drive_file</mat-icon>
            <span class="ellipsis">{{ item.name}}</span>
          </div>
          <div *ngIf="!item.files" class="size">
            {{ item.size | fsFileSize  }}</div>
          <div *ngIf="item.files" class="size">{{ item.files.length }} items</div>
          <div
            *ngIf="!item.speed || item.state === UPLOAD_FINISHED || item.state === UPLOAD_ERROR || item.state === UPLOAD_PAUSED_ON_ERROR"
            class="status">
            <mat-icon style="display: inline-block; margin-right: 10px;" *ngIf=" item.state === UPLOAD_FINISHED"
              class="success-upload">check_circle</mat-icon>
            <span [matTooltip]="item.errorMsg"
              [matTooltipDisabled]="item.state !== UPLOAD_ERROR && item.state !== UPLOAD_PAUSED_ON_ERROR">
              {{ item.state }}</span>
          </div>
          <div
            *ngIf="item.speed && item.state !== UPLOAD_FINISHED && item.state !== UPLOAD_ERROR && item.state !== UPLOAD_PAUSED_ON_ERROR"
            class="status">
            <mat-spinner ng-if="item.state === UPLOAD_UPLOADING" color="accent"
              style="display: inline-block; margin-right: 10px;" [diameter]="24"></mat-spinner>
            {{  item.size ? getSpeedWithProgress(item) : item.speed }}
          </div>
          <div (click)="handleDeleteItem(item)" class="actions">
            <mat-icon>delete</mat-icon>
          </div>
        </div>
      </div>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions fxLayout="row" fxLayoutAlign="end end" mat-dialog-actions>
  <mat-progress-bar [style.visibility]="isActiveUpload ? 'visible' : 'hidden' " color="accent" mode="determinate"
    [value]="progress">
  </mat-progress-bar>
  <button mat-button class="cancel" (click)="onNoClick(true)">
    Cancel
  </button>
  <button mat-raised-button color="primary" name="submitButton" [disabled]="isEmpty || isUploadDisabled"
    class="start-button" (click)="handleUploadStart()">
    {{ uploadButtonState }}
  </button>
</mat-dialog-actions>